import axios from 'axios'
import BaseProxy from './BaseProxy'

export class PlanimetryProxy extends BaseProxy {
  constructor() {
    super()
    this._baseUrl = `${this._baseUrl}/api/planimetry`
  }

  async getLayouts(locationId) {
    const response = await axios.get(`${this._baseUrl}/layouts/${locationId}`)
    return response.data
  }

  async getLayoutOptions(locationId) {
    const response = await axios.get(
      `${this._baseUrl}/layout-options/${locationId}`
    )
    return response.data
  }

  async getSectors(layoutId) {
    const response = await axios.get(`${this._baseUrl}/sectors/${layoutId}`)
    return response.data
  }

  async getSeats(sectorId) {
    const response = await axios.get(`${this._baseUrl}/seats/${sectorId}`)
    return response.data
  }

  async getSeatsInfoSell(sectorId) {
    const response = await axios.get(`${this._baseUrl}/seats/${sectorId}/sell`)
    return response.data
  }

  async getLayoutById(layoutId) {
    const response = await axios.get(`${this._baseUrl}/layout/${layoutId}`)
    return response.data
  }

  async getSectorById(sectorId) {
    const response = await axios.get(`${this._baseUrl}/sector/${sectorId}`)
    return response.data
  }

  async postLayout(ImageFile, LayoutName, LocationId) {
    const formData = new FormData()

    formData.append('ImageFile', ImageFile)
    formData.append('LayoutName', LayoutName)
    formData.append('LocationId', LocationId)

    const response = await axios.post(`${this._baseUrl}/layout`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return response.data
  }

  async putLayout(layoutId, ImageFile, LayoutName, LocationId) {
    const formData = new FormData()

    formData.append('Id', layoutId)
    formData.append('ImageFile', ImageFile)
    formData.append('LayoutName', LayoutName)
    formData.append('LocationId', LocationId)

    const response = await axios.put(`${this._baseUrl}/layout`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return response.data
  }

  async postSector(
    ImageId,
    ImageFile,
    SectorName,
    LayoutId,
    Row,
    RowDescriptor,
    Column,
    ColumnDescriptor,
    Color
  ) {
    const formData = new FormData()
    formData.append('ImageId', ImageId)
    formData.append('ImageFile', ImageFile)
    formData.append('SectorName', SectorName)
    formData.append('layoutId', LayoutId)
    formData.append('Row', Row)
    formData.append('RowDescriptor', RowDescriptor)
    formData.append('Column', Column)
    formData.append('ColumnDescriptor', ColumnDescriptor)
    formData.append('SectorColor', Color)

    const response = await axios.post(`${this._baseUrl}/sector`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return response.data
  }

  async putSector(
    SectorId,
    ImageId,
    ImageFile,
    SectorName,
    LayoutId,
    Row,
    RowDescriptor,
    Column,
    ColumnDescriptor,
    Color
  ) {
    const formData = new FormData()

    formData.append('Id', SectorId)
    formData.append('ImageId', ImageId)
    formData.append('ImageFile', ImageFile)
    formData.append('SectorName', SectorName)
    formData.append('layoutId', LayoutId)
    formData.append('Row', Row)
    formData.append('RowDescriptor', RowDescriptor)
    formData.append('Column', Column)
    formData.append('ColumnDescriptor', ColumnDescriptor)
    formData.append('SectorColor', Color)

    const response = await axios.put(`${this._baseUrl}/sector`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return response.data
  }

  async postSeats(payload) {
    const response = await axios.post(`${this._baseUrl}/seats`, payload)

    return response.data
  }

  async putSeats(payload) {
    const response = await axios.put(`${this._baseUrl}/seats`, payload)

    return response.data
  }

  async deleteLayout(layoutId) {
    const response = await axios.delete(`${this._baseUrl}/layout/${layoutId}`)

    return response.data
  }

  async deleteSector(sectorId) {
    const response = await axios.delete(`${this._baseUrl}/sector/${sectorId}`)

    return response.data
  }

  async assignLayoutToEvent(LayoutId, EventId) {
    const response = await axios.post(
      `${this._baseUrl}/assign-layout-to-event`,
      { LayoutId, EventId }
    )

    return response.data
  }

  async getAssignableTickets(layoutId, sectorId, eventId) {
    const response = await axios.get(
      `${this._baseUrl}/${layoutId}/sector/${sectorId}/assignable-tickets/${eventId}`
    )
    const data = response.data

    data.sort((a, b) => {
      if (a.TicketUsage === b.TicketUsage) {
        return a.Id - b.Id
      }
      return a.TicketUsage - b.TicketUsage
    })

    return data
  }

  async assignTicketToSector(layoutId, sectorId, ticketTypeId) {
    const response = await axios.post(
      `${this._baseUrl}/assign-ticket-to-sector`,
      { layoutId, sectorId, ticketTypeId }
    )

    return response.data
  }
}

export default PlanimetryProxy
